module.exports = __webpack_public_path__ + "static/media/lt-surge-miss.fc128504.wav";